import { fetchRecommendProducts } from '../../../services/api/tariff';

export const tariffCalculate = {
    namespaced: true,
    state: {
        products: [],
    },
    mutations: {
        save(state, products) {
            state.products = products;
        },
    },
    actions: {
        fetchRecommendProducts({ commit, dispatch }) {
            return fetchRecommendProducts()
                .then((res) => {
                    commit('save', res.data);

                    return res;
                })
                .catch((res) => {
                    dispatch('error', res, { root: true });

                    throw res;
                });
        },
    },
    getters: {
        products({ products }) {
            return products;
        },
        isFetched({ products }) {
            return products.length > 0;
        }
    }
};


// WEBPACK FOOTER //
// ./src/modules/home/tariffCalculate/store.js